/**
 * Tiny prefetch + stale-while-revalidate helpers for list pages.
 *
 *  - `prefetch(key, fn)`   fire a request at app boot (parallel with the auth
 *                          check) and park the promise; `takePrefetched(key)`
 *                          hands it to the page that mounts later.
 *  - `readCache/writeCache` sessionStorage snapshot of the last response so a
 *                          list paints instantly on revisit, then revalidates.
 */
const inflight = {};

export function prefetch(key, fn) {
  if (!inflight[key]) inflight[key] = fn().catch(() => null);
  return inflight[key];
}

export function takePrefetched(key) {
  const p = inflight[key] || null;
  delete inflight[key];
  return p;
}

const PREFIX = "swr:";

export function readCache(key) {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function writeCache(key, value) {
  try { sessionStorage.setItem(PREFIX + key, JSON.stringify(value)); } catch { /* quota / private mode */ }
}

export function clearCache(key) {
  try { sessionStorage.removeItem(PREFIX + key); } catch { /* ignore */ }
}
